import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePrivy } from "@privy-io/react-auth";
import { Button } from "@/components/ui/Button";
import { useAuth } from "@/hooks/useAuth";
import { useAppLogin, useMockAuth } from "@/hooks/useAppAuth";
import { LanguageSwitcher } from "@/components/ui/LanguageSwitcher";
import { BrandMark } from "@/components/ui/BrandMark";
import { BRAND_NAME } from "@/lib/brand";
import { FEEDBACK_URL } from "@/lib/constants";
import { ShellBackButton } from "./ShellBackButton";

function MockSignInButton() {
  const { loginMock } = useAppLogin();
  const { t } = useTranslation();

  return (
    <button
      onClick={loginMock}
      className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors"
    >
      {t("home.signIn")}
    </button>
  );
}

function PrivySignInButton() {
  const { login } = usePrivy();
  const { t } = useTranslation();

  return (
    <button
      onClick={() => login()}
      className="text-sm font-medium text-text-secondary hover:text-text-primary transition-colors"
    >
      {t("home.signIn")}
    </button>
  );
}

function MockGetStartedButton() {
  const { loginMock } = useAppLogin();
  const { t } = useTranslation();

  return (
    <Button size="sm" onClick={loginMock}>
      {t("home.getStarted")}
    </Button>
  );
}

function PrivyGetStartedButton() {
  const { login } = usePrivy();
  const { t } = useTranslation();

  return (
    <Button size="sm" onClick={() => login()}>
      {t("home.getStarted")}
    </Button>
  );
}

export function PublicNavbar() {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  // Don't show auth buttons if already authenticated (redirect will happen)
  if (isAuthenticated) return null;

  return (
    <header className="sticky top-0 z-50 border-b border-border-subtle bg-surface/80 backdrop-blur-lg">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-6">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <ShellBackButton isAuthenticated={false} className="-ml-2" />
          <BrandMark className="h-8 w-8" />
          {/* Under 360px the es CTA ("Comenzar") + language switcher leave no
              room for the wordmark; the mark alone still carries the brand. */}
          <span className="text-lg font-bold text-text-primary max-[359px]:hidden">{BRAND_NAME}</span>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-2 sm:gap-4">
          <Link
            to="/bounties"
            className="hidden text-sm font-medium text-text-secondary hover:text-text-primary transition-colors sm:block"
          >
            {t("publicBounties.browseBounties", "Browse Bounties")}
          </Link>
          <a
            href={FEEDBACK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden text-sm font-medium text-text-secondary hover:text-text-primary transition-colors md:block"
          >
            {t("nav.feedback")}
          </a>
          <LanguageSwitcher />
          <span className="hidden sm:inline">
            {useMockAuth ? <MockSignInButton /> : <PrivySignInButton />}
          </span>
          {useMockAuth ? <MockGetStartedButton /> : <PrivyGetStartedButton />}
        </div>
      </div>
    </header>
  );
}
